import { render, staticRenderFns } from "./gxzy_add.vue?vue&type=template&id=4b9a2d30&"
import script from "./gxzy_add.vue?vue&type=script&lang=js&"
export * from "./gxzy_add.vue?vue&type=script&lang=js&"
import style0 from "./gxzy_add.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports